import React, { memo } from 'react';
import { useMessageContext } from "../../../../context/MessageContext/context";
import { getDisplayColor } from '../../../../helpers';
import { useAppContext } from '../../../../context/AppContext/AppContext';
import { useChatChatter } from '../../../../redux/services/nebulaChat';

interface IMessageSenderProps {
}

export const MessageSender: React.FC<IMessageSenderProps> = memo(
    () => {
        const { message } = useMessageContext();
        const { darkMode } = useAppContext();

        const chatter = useChatChatter({ userUuid: message.from });

        return <h4 className={getDisplayColor(message.from, false, darkMode)}>{chatter.name}</h4>;
    },
    (prevProps, nextProps) => prevProps === nextProps
);
